export type EnvLabel = 'TEST' | 'DEV';

export const getNodeEnv = (): string => {
  if (typeof window !== 'undefined') {
    const env = (window as { __NODE_ENV__?: string }).__NODE_ENV__;
    if (env) return env;
  }
  return import.meta.env.MODE;
};

export const getEnvLabel = (): EnvLabel | null => {
  const nodeEnv = getNodeEnv();
  if (nodeEnv === 'test') return 'TEST';
  if (nodeEnv === 'development') return 'DEV';
  return null;
};
